//@flow
import React from 'react';
import ZoneMapEditViewContainer from 'common/containers/ZoneMapEditViewContainer';
import { connect } from 'react-redux';

import {
    clientSelector,
    currentMapIdSelector,
    mapActiveStatusSelector,
    mapVersionSelector
} from 'common/redux/selectors/queryParamsSelectors';

import { sessionSelector } from 'common/redux/selectors/sessionSelector';
import ZoneMapSelectors from 'common/redux/selectors/zoneMap';
import ZoneMapActions from 'common/redux/actions/zoneMap';

import { withRouter } from 'common/components/core/router';
import compose from 'recompose/compose';

const mapStateToProps = (state, props) => {
    const clientId = clientSelector(state, props);
    const session = sessionSelector(state, props);
    const mapId = currentMapIdSelector(state, props);
    const zoneMap = ZoneMapSelectors.getSelectedMap(state, props);
    const selectedHomebase = ZoneMapSelectors.getSelectedMapHomebase(
        state,
        props
    );
    const mapActiveStatus = mapActiveStatusSelector(state, props);
    const mapVersion = mapVersionSelector(state, props);
    const isMapLoading = ZoneMapSelectors.isSelectedMapLoading(state, props);
    const mapLoadError = ZoneMapSelectors.selectedMapErrorSelector(
        state,
        props
    );

    return {
        clientId,
        session,
        initialZoneMap: zoneMap,
        mapId,
        mapVersion,
        mapActiveStatus,
        isMapLoading,
        mapLoadError,
        homebase: selectedHomebase
    };
};

const actions = {
    fetchZoneMap: ZoneMapActions.fetchEntity
};

class ZoneMapModalComponent extends React.PureComponent {
    componentDidMount() {
        const {
            clientId,
            mapId,
            fetchZoneMap,
            mapActiveStatus,
            mapVersion
        } = this.props;
        mapId &&
            fetchZoneMap({
                clientId,
                mapId,
                active: mapActiveStatus,
                versionId: mapVersion,
                populateDefaultCenter: true /* if no zones are there then BE will
                                            fetch and pass defaultCenter in response */
            });
    }
    componentDidUpdate(prevProps) {
        const {
            clientId,
            mapId,
            fetchZoneMap,
            initialZoneMap,
            mapActiveStatus,
            mapVersion,
            mapLoadError,
            isMapLoading
        } = this.props;
        if (
            (!initialZoneMap && !mapLoadError && !isMapLoading) ||
            (mapId && mapId !== prevProps.mapId) ||
            mapActiveStatus !== prevProps.mapActiveStatus ||
            mapVersion !== prevProps.mapVersion
        ) {
            fetchZoneMap({
                clientId,
                mapId,
                active: mapActiveStatus,
                versionId: mapVersion
            });
        }
    }

    onBack = ({
        isConfirmDialogOpen,
        pushRoute = true
    }: {
        // save confirmation dialog is open
        isConfirmDialogOpen: boolean,
        /**
         * Callback after user click on save or don't save button
         * location change is handled by `NavigationPrompt > onConfirm`
         */
        pushRoute: boolean
    }): void => {
        const { history, clientId, onBack } = this.props;
        if (pushRoute) {
            history.push({
                pathname: `/client/${clientId}/entity/map`
            });
        }
        if (onBack && !isConfirmDialogOpen) {
            onBack();
        }
    };

    render() {
        return (
            <ZoneMapEditViewContainer {...this.props} onBack={this.onBack} />
        );
    }
}

const ZoneMapModal = compose(
    withRouter,
    connect(mapStateToProps, actions)
)(ZoneMapModalComponent);

export default ZoneMapModal;
